import { keyframes } from '@emotion/react';

export const AnimationSlideRight = (end = 0) => keyframes`
0%{
  transform: translateX(-20px);
  opacity: 0;
}

100%{
  transform: translateX('${end}px');
  opacity: 1;
}
`;

export const AnimationFadeIn = () => keyframes`
  0%{
    opacity: 0;
  }

  100%{
    opacity: 1;
  }
`;

export const AnimationSlideDown = () => keyframes`
    0%{
        transform: translate(0, -20px);
        opacity: 0;
    }

    100%{
        transform: translate(0, 0);
        opacity: 1;
    }
`;

export const AnimationSlideUp = () => keyframes`
    0%{
        transform: translate(0, 20px);
        opacity: 0;
    }

    100%{
        transform: translate(0, 0);
        opacity: 1;
    }
`;

export const AnimationPulse = () => keyframes`
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.4;
  }
`;
